"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.noPrefixFields = void 0;
var types_1 = require("../types");
exports.noPrefixFields = (_a = {
        common: [
            "app_name",
            "adjust_id",
            "google_ad_id",
            "device_uuid",
            "session_id",
            "self_session_id",
            "screen_order",
            "screen_referrer_num",
            "screen_referrer_order",
            "adjust_action_timestamp",
            "business_type",
            "$app_version",
        ]
    },
    _a[types_1.EventType.View] = ["Page_stayTime"],
    _a[types_1.EventType.Click] = ["click_order"],
    _a[types_1.EventType.PopClick] = ["click_order"],
    _a[types_1.EventType.PopView] = ["duration"],
    _a[types_1.EventType.Expose] = ["duration"],
    _a[types_1.EventType.Input] = ["input_order"],
    _a[types_1.EventType.ActivityView] = ["Page_stayTime"],
    _a[types_1.EventType.ActivityClick] = ["click_order"],
    _a[types_1.EventType.ActivityInput] = ["input_order"],
    _a);
